import React, { Component } from 'react'
import { Modal, PickerView, DatePickerView } from 'antd-mobile'
import PropTypes from 'prop-types'
import df from 'dateformat'
import { weekToDate, dateToWeek, getWeeksByYear } from '../utils/weekToDate'
import './datepicker.css'

class DatePicker extends Component {
  constructor(props) {
    super(props)
    let mode = this.props.mode || 'date'
    let defaultValues = this.props.defaultValues
    let startDate
    let endDate
    let startWeek
    let endWeek
    if (typeof defaultValues === 'undefined') {
      startDate = new Date()
      endDate = new Date()
      startWeek = dateToWeek(startDate)
      endWeek = dateToWeek(endDate)
    } else if (defaultValues[0] instanceof Date) {
      startDate = new Date(defaultValues[0].getTime())
      endDate = new Date(defaultValues[1].getTime())
      startWeek = dateToWeek(startDate)
      endWeek = dateToWeek(endDate)
    } else if (typeof defaultValues[0] === 'string') {
      startWeek = defaultValues[0]
      endWeek = defaultValues[1]
      startDate = weekToDate(startWeek)
      endDate = weekToDate(endDate)
    }
    let weekMap = {}
    for (let i = 2000, len = 2031; i < len; i++) {
      let weeks = getWeeksByYear(i + '')
      weeks.forEach(item => {
        weekMap[item.label] = item
      })
    }
    this.state = {
      mode,
      weekMap,
      startDate,
      endDate,
      startWeek,
      endWeek,
      startWeekInfo: weekMap[startWeek],
      endWeekInfo: weekMap[endWeek],
      currentSelected: 0,
      currentModeIndex: 0
    }
  }
  onCancel = () => {
    if (typeof this.props.onCancel === 'function') {
      this.props.onCancel()
    }
  }
  // componentWillReceiveProps = () => {
  //   let mode = this.props.mode || 'date'
  //   let defaultValues = this.props.defaultValues
  //   let startDate
  //   let endDate
  //   let startWeek
  //   let endWeek
  //   const { weekMap } = this.state
  //   if (typeof defaultValues === 'undefined') {
  //     startDate = new Date()
  //     endDate = new Date()
  //     startWeek = dateToWeek(startDate)
  //     endWeek = dateToWeek(endDate)
  //   } else if (defaultValues[0] instanceof Date) {
  //     startDate = new Date(defaultValues[0].getTime())
  //     endDate = new Date(defaultValues[1].getTime())
  //     startWeek = dateToWeek(startDate)
  //     endWeek = dateToWeek(endDate)
  //   } else if (typeof defaultValues[0] === 'string') {
  //     startWeek = defaultValues[0]
  //     endWeek = defaultValues[1]
  //     startDate = weekToDate(startWeek)
  //     endDate = weekToDate(endDate)
  //   }
  //   this.setState({
  //     mode,
  //     startDate,
  //     endDate,
  //     startWeek,
  //     endWeek,
  //     startWeekInfo: weekMap[startWeek],
  //     endWeekInfo: weekMap[endWeek],
  //     currentSelected: 0,
  //     currentModeIndex: 0
  //   })
  // }
  onSubmit = () => {
    const {
      currentModeIndex,
      startDate,
      endDate,
      startWeekInfo,
      endWeekInfo,
      mode
    } = this.state
    let currentMode
    if (Array.isArray(mode)) {
      currentMode = mode[currentModeIndex]
    } else {
      currentMode = mode
    }
    if (typeof this.props.onConfirm === 'function') {
      let start
      let end
      if (currentMode === 'date' || currentMode === 'month') {
        if (this.state.startDate.getTime() < this.state.endDate.getTime()) {
          start = startDate
          end = endDate
        } else {
          end = startDate
          start = endDate
        }
      } else {
        if (startWeekInfo.startDate.getTime() < endWeekInfo.endDate.getTime()) {
          start = startWeekInfo
          end = endWeekInfo
        } else {
          end = startWeekInfo
          start = endWeekInfo
        }
      }
      this.props.onConfirm(start, end, currentMode)
    }
  }
  renderDate() {
    const {
      startDate,
      endDate,
      currentSelected,
      currentModeIndex,
      mode
    } = this.state
    return (
      <React.Fragment>
        <div className="range-container">
          <div
            className={
              currentSelected === 0 ? 'date-label active' : 'date-label'
            }
            onClick={() => {
              this.setState({ currentSelected: 0 })
            }}
          >
            {df(
              startDate,
              mode === 'date' || mode[currentModeIndex] === 'date'
                ? 'yyyy-mm-dd'
                : 'yyyy-mm'
            )}
          </div>
          至
          <div
            className={
              currentSelected === 1 ? 'date-label active' : 'date-label'
            }
            onClick={() => {
              this.setState({ currentSelected: 1 })
            }}
          >
            {df(
              endDate,
              mode === 'date' || mode[currentModeIndex] === 'date'
                ? 'yyyy-mm-dd'
                : 'yyyy-mm'
            )}
          </div>
        </div>
        <DatePickerView
          value={currentSelected === 0 ? startDate : endDate}
          onChange={val => {
            if (currentSelected === 0) {
              this.setState({
                startDate: val
              })
            } else {
              this.setState({
                endDate: val
              })
            }
          }}
          mode={Array.isArray(mode) ? mode[currentModeIndex] : mode}
        />
      </React.Fragment>
    )
  }
  renderWeek() {
    const { startWeek, endWeek, currentSelected, weekMap } = this.state
    let years = []
    for (let i = 2000, len = 2031; i < len; i++) {
      let weeks = getWeeksByYear(i + '')
      let children = []
      function getDateLabel(date) {
        return date.getMonth() + 1 + '.' + date.getDate()
      }
      weeks.forEach(item => {
        children.push({
          label:
            item.label +
            ' (' +
            getDateLabel(item.startDate) +
            '-' +
            getDateLabel(item.endDate) +
            ')',
          value: item.label
        })
      })
      years.push({
        label: i + '年',
        value: i + '',
        children: children
      })
    }
    return (
      <React.Fragment>
        <div className="range-container">
          <div
            className={
              currentSelected === 0 ? 'date-label active' : 'date-label'
            }
            onClick={() => {
              this.setState({ currentSelected: 0 })
            }}
          >
            {startWeek}
          </div>
          至
          <div
            className={
              currentSelected === 1 ? 'date-label active' : 'date-label'
            }
            onClick={() => {
              this.setState({ currentSelected: 1 })
            }}
          >
            {endWeek}
          </div>
        </div>

        <PickerView
          data={years}
          cols={2}
          cascade={true}
          value={
            currentSelected === 0
              ? ['20' + startWeek.substring(0, 2), startWeek]
              : ['20' + endWeek.substring(0, 2), endWeek]
          }
          onChange={val => {
            if (currentSelected === 0) {
              this.setState({
                startWeek: val[1],
                startWeekInfo: weekMap[val[1]]
              })
            } else {
              this.setState({
                endWeek: val[1],
                endWeekInfo: weekMap[val[1]]
              })
            }
          }}
        />
      </React.Fragment>
    )
  }
  switchMode = () => {
    const { mode } = this.props
    const { currentModeIndex } = this.state
    this.setState({
      currentModeIndex:
        currentModeIndex === mode.length - 1 ? 0 : currentModeIndex + 1,
      currentSelected: 0
    })
  }
  render() {
    const props = this.props
    const { currentModeIndex } = this.state
    const { mode } = props
    const labels = {
      date: '按日期选择',
      month: '按月选择',
      week: '按周选择'
    }
    return (
      <Modal
        className="custom-date-picker"
        popup
        animationType="slide-up"
        visible={this.props.visible}
      >
        <div className="custom-date-picker-header">
          <div className="btn" onClick={this.onCancel}>
            取消
          </div>
          <div className="btn" onClick={this.onSubmit}>
            确定
          </div>
        </div>
        {Array.isArray(mode) ? (
          <div className="c-picker-switch-container" onClick={this.switchMode}>
            <span className="c-picker-switch">
              {labels[mode[currentModeIndex]]}
            </span>
          </div>
        ) : null}
        {mode[currentModeIndex] === 'month' ||
        mode[currentModeIndex] === 'date' ||
        mode === 'month' ||
        mode === 'date'
          ? this.renderDate()
          : null}
        {mode[currentModeIndex] === 'week' || mode === 'week'
          ? this.renderWeek()
          : null}
      </Modal>
    )
  }
}
DatePicker.propTypes = {
  type: PropTypes.oneOf(['one', 'range']), // 日期选择为单选还是范围选择
  mode: PropTypes.oneOfType([PropTypes.array, PropTypes.string]), // week按照周选择 year按照月选择 month按照月选择 date按照日选择
  minDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]), //最小值 按照周选择使用字符串格式 年月日使用日期格式
  maxDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]), //最大值 按照周选择使用字符串格式 年月日使用日期格式
  defaultValues: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.instanceOf(Date),
    PropTypes.string
  ]) //开始日期 按照周选择使用字符串格式 年月日使用日期格式
}
export default DatePicker
